/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { utils, Contract, ContractFactory } from "ethers";
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldContract",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newContract",
                type: "address",
            },
        ],
        name: "ContractUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "chainId_",
                type: "uint16",
            },
        ],
        name: "bridgeContracts",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "chainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVm",
                type: "bytes",
            },
        ],
        name: "completeTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "tokenAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "tokenChain",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "symbol",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "name",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "tokenID",
                        type: "uint256",
                    },
                    {
                        internalType: "string",
                        name: "uri",
                        type: "string",
                    },
                    {
                        internalType: "bytes32",
                        name: "to",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "toChain",
                        type: "uint16",
                    },
                ],
                internalType: "struct NFTBridgeStructs.Transfer",
                name: "transfer",
                type: "tuple",
            },
        ],
        name: "encodeTransfer",
        outputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
        ],
        name: "governanceActionIsConsumed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceChainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceContract",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "impl",
                type: "address",
            },
        ],
        name: "isInitialized",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
        ],
        name: "isTransferCompleted",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "isWrappedAsset",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "onERC721Received",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        name: "parseRegisterChain",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "uint16",
                        name: "chainId",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "emitterChainID",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "emitterAddress",
                        type: "bytes32",
                    },
                ],
                internalType: "struct NFTBridgeStructs.RegisterChain",
                name: "chain",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        name: "parseTransfer",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "tokenAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "tokenChain",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "symbol",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "name",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "tokenID",
                        type: "uint256",
                    },
                    {
                        internalType: "string",
                        name: "uri",
                        type: "string",
                    },
                    {
                        internalType: "bytes32",
                        name: "to",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "toChain",
                        type: "uint16",
                    },
                ],
                internalType: "struct NFTBridgeStructs.Transfer",
                name: "transfer",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        name: "parseUpgrade",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "uint16",
                        name: "chainId",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "newContract",
                        type: "bytes32",
                    },
                ],
                internalType: "struct NFTBridgeStructs.UpgradeContract",
                name: "chain",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVM",
                type: "bytes",
            },
        ],
        name: "registerChain",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "splCache",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "name",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "symbol",
                        type: "bytes32",
                    },
                ],
                internalType: "struct NFTBridgeStorage.SPLCache",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "tokenImplementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenID",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "recipientChain",
                type: "uint16",
            },
            {
                internalType: "bytes32",
                name: "recipient",
                type: "bytes32",
            },
            {
                internalType: "uint32",
                name: "nonce",
                type: "uint32",
            },
        ],
        name: "transferNFT",
        outputs: [
            {
                internalType: "uint64",
                name: "sequence",
                type: "uint64",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVM",
                type: "bytes",
            },
        ],
        name: "upgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "wormhole",
        outputs: [
            {
                internalType: "contract IWormhole",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "tokenChainId",
                type: "uint16",
            },
            {
                internalType: "bytes32",
                name: "tokenAddress",
                type: "bytes32",
            },
        ],
        name: "wrappedAsset",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "testNewImplementationActive",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
var _bytecode = "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";
var MockNFTBridgeImplementation__factory = /** @class */ (function (_super) {
    __extends(MockNFTBridgeImplementation__factory, _super);
    function MockNFTBridgeImplementation__factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MockNFTBridgeImplementation__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    MockNFTBridgeImplementation__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    MockNFTBridgeImplementation__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MockNFTBridgeImplementation__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MockNFTBridgeImplementation__factory.createInterface = function () {
        return new utils.Interface(_abi);
    };
    MockNFTBridgeImplementation__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    };
    MockNFTBridgeImplementation__factory.bytecode = _bytecode;
    MockNFTBridgeImplementation__factory.abi = _abi;
    return MockNFTBridgeImplementation__factory;
}(ContractFactory));
export { MockNFTBridgeImplementation__factory };
